import { Common } from "./common";
import { ButtonsSection, DataDisclaimer, Deeplink, Searcher, Sidebar, TableNotification } from "./components";
import { ClickModal, DeeplinkModal } from "./components/modals";
import {
  CurrencySelector,
  DateRangeSelector,
  GatesSelector,
  MarketSelector,
  ReportSelector,
  ResolutionSelector,
} from "./components/selectors";
import { ApiStateWidget, ConversionsWidget, FilteredAirlinesWidget, Widget } from "./components/widgets";
import {
  AirlinesPage,
  AirlinesProductivityPage,
  AlertsPage,
  AuctionPage,
  BookingsPage,
  ClicksPage,
  ContactPage,
  ConversionsPage,
  DashboardPage,
  DebugPage,
  ExtendedReportPage,
  FAQPage,
  FeedbacksPage,
  GateTesterPage,
  HostsPage,
  HttpErrorPage,
  IntegrationErrorsPage,
  LoginPage,
  ReportsPage,
  RoutesPage,
} from "./pages";

const pages = {
  airlines_page: AirlinesPage,
  airlines_productivity_page: AirlinesProductivityPage,
  alerts_page: AlertsPage,
  auction_page: AuctionPage,
  bookings_page: BookingsPage,
  clicks_page: ClicksPage,
  contact_page: ContactPage,
  conversions_page: ConversionsPage,
  dashboard_page: DashboardPage,
  debug_page: DebugPage,
  extended_report_page: ExtendedReportPage,
  faq_page: FAQPage,
  feedbacks_page: FeedbacksPage,
  gate_tester_page: GateTesterPage,
  hosts_page: HostsPage,
  http_error_page: HttpErrorPage,
  integration_errors_page: IntegrationErrorsPage,
  login_page: LoginPage,
  reports_page: ReportsPage,
  routes_page: RoutesPage,
};

const components = {
  buttons_section: ButtonsSection,
  sidebar: Sidebar,
  table_notification: TableNotification,
  currency_selector: CurrencySelector,
  date_range_selector: DateRangeSelector,
  gate_selector: GatesSelector,
  market_selector: MarketSelector,
  resolution_selector: ResolutionSelector,
  searcher: Searcher,
  widget: Widget,
  filtered_airlines_widget: FilteredAirlinesWidget,
  conversions_widget: ConversionsWidget,
  api_state_widget: ApiStateWidget,
  deeplink_modal: DeeplinkModal,
  click_modal: ClickModal,
  deeplink: Deeplink,
  data_disclaimer: DataDisclaimer,
  report_selector: ReportSelector,
};

const enTranslations = { common: Common, ...pages, ...components };

export default enTranslations;
